export default "/_next/static/media/ezgif.com-gif-maker.6f44514fe95e965da58b343373e7d015.jpg";